import SettingsIndex, { saction, ploader } from './index';
//import CryptoDeposit from './Crypto';
//import Crypto from './Crypto';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import af from './style.module.scss';

function Settings() {
  return (
    <div>
      <div className={af.body}>
        <Outlet />
      </div>
    </div>
  );
}
//    { index: true, element: <AddFundsIndex /> },

export const settingsroutes = {
  path: `settings`,
  //loader: mostrloader(apiContext),
  element: <Settings />,
  children: [
    { index: true, element: <SettingsIndex />, action: saction, loader: ploader },
    /*{
      path: 'crypto',
      element: <CryptoDeposit />,
      //loader: contactLoader,
    },*/
  ],
};
